export default {
  // 导航菜单
  nav: {
    brand: "品牌介绍",
    brandStory: "品牌故事",
    designerStory: "设计师故事",
    brandCraftsmanship: "品牌工艺",
    brandBlockbuster: "品牌大片",
    brandHonor: "品牌荣誉与社会责任",
    news: "品牌新闻",
    latest: "最新动态",
    media: "媒体报道",
    activity: "活动资讯",
    trend: "流行趋势",
    map: "门店地图",
    mapDistribution: "全国门店分布",
    mapDetail: "门店详情",
    contact: "联系我们",
    contactInfo: "联系方式",
    cooperation: "合作洽谈",
  },
  // 语言切换
  language: {
    zh: "简体中文",
    en: "English",
    zhShort: "简",
    enShort: "En",
  },
  // 底部相关
  footer: {
    certification: "2025年 | 荣获沙利文认证",
    certificationSilk: "连续3年 【中国丝绸女装】 销售额第一",
    certificationXiangyunsha: "连续3年 【中国香云纱女装】 销售额第一",
    certificationCertificateNumber: "证书标号：{number}",
    certificationOrigin: "来源:弗若斯特沙利文(北京)咨询有限公司上海分公司",
    contactAddress:
      "浙江省 杭州市 上城区 水澄路 山南印中心5号楼响隐香云纱丝绸杭州总部",
    copyright: "Copyright © 2025 响隐 Shine Into 版权所有",
    privacyPolicy: "隐私政策",
    legalStatement: "法律声明",
  },
  // 联系相关
  contact: {
    companyEnName: "Hangzhou Shine into Garments Co., Ltd.",
    companyCName: "杭州响隐服饰有限公司",
    companyAddress: "公司地址",
    companyAddressContent: "杭州市上城区山南印5号楼d栋响隐香云纱丝绸",
    companyPhone: "公司总机",
    cooperation: "商务合作",
    contactHotline: "热线电话（产品询价）",
    contactOurTeamEn: "Contact Our Team",
    contactOurTeamCn: "联系我们的团队",
    contactOurTeamDesc: "项目合作需求，您可以联系我们或者来电洽谈",
    email: "E-Mall",
    form: {
      name: "姓名",
      company: "公司",
      email: "邮箱",
      phone: "电话",
      message: "请输入留言内容",
      submit: "提交",
      submitSuccess: "提交成功",
      submitFailed: "提交失败",
    },
  },
  // 通用
  common: {
    loading: "加载中...",
    noData: "暂无数据",
    loadMore: "加载更多",
    back: "返回",
    confirm: "确认",
    cancel: "取消",
    submit: "提交",
    search: "搜索",
    reset: "重置",
  },
  // 新闻相关
  news: {
    loadMore: '加载更多',
    loading: '加载中...',
    noMore: '没有更多了',
    loadFailed: '加载失败，点击重试',
    more: '更多',
    currentLocation: '当前位置',
    viewDetail: '查看详情',
    original: '源文',
  },
  // 地图相关
  map: {
    title: '门店地图',
    desc: '门店数据截止到{date}',
    search: '搜索',
    selectArea: '请选择区域',
    emptyText: '暂无数据，换个区域试试？',
    resultTitle: '响隐门店',
  },
};
